interface PlacementMetricsRow {
  ad_sales_clicks: number;
  ad_sales_views: number;
  ad_spend: number;
  clicks: number;
  impressions: number;
  conversions_clicks: number;
  conversions_views: number;
  ad_sales: number;
  roas: number;
  acos: number;
  ctr: number;
  conversions: number;
  conv_rate: number;
  cost_per_click: number;
}

/**
 * Compute derived placement metrics on a totals/row object in place.
 * Shared between useAMCReportData, groupByKey, and groupBySearchTermAndPlacement.
 */
export const computeDerivedPlacementMetrics = (total: Partial<PlacementMetricsRow>) => {
  total.ad_sales = (total.ad_sales_clicks || 0) + (total.ad_sales_views || 0);
  total.roas = total.ad_sales / (total.ad_spend || 0);
  total.acos = (total.ad_spend || 0) / total.ad_sales;
  total.ctr = (total.clicks || 0) / (total.impressions || 0);
  total.conversions = (total.conversions_clicks || 0) + (total.conversions_views || 0);
  total.conv_rate = total.conversions / (total.clicks || 0);
  total.cost_per_click = (total.ad_spend || 0) / (total.clicks || 0);
};
